import logo from "./logo.svg";
import "./App.css";
import MomentoMori from "./components/MomentoMori";
import "bootstrap/dist/css/bootstrap.min.css";
import Calender from "./components/Calender";

function App() {
  return (
    <div className="App">
      <Calender />
    </div>
  );
}

export default App;
